import { ReactElement } from 'react';

export function NudgeMessaging({
  message,
}: Readonly<{ message: string }>): ReactElement {
  return (
    <div className="mb-1 w-fit rounded bg-dollar/25 p-2 text-center text-xs font-semibold text-midnight md:mb-2">
      <span>{message}</span>
    </div>
  );
}
